import { createAction } from '@reduxjs/toolkit';

import type { UpdateLicenceInput } from '../../_shared/domain/licence-edit';
import type { SetLicenceStatusInput } from '../infrastructure/licences.gateway';

/**
 * "Signal" actions: intents the UI dispatches for the saga to act on. Kept out
 * of the slice's reducers: they trigger side effects, not state transitions (the
 * saga owns the resulting `load*` transitions).
 */

/** Load the org's licences (dispatched on mount). */
export const loadRequested = createAction('licences/loadRequested');

/** Load the org-wide KPI figures (dispatched on mount, alongside the rows). */
export const statsRequested = createAction('licences/statsRequested');

/** Deactivate or reactivate a row's licence, after the page's confirmation. */
export const statusChangeRequested = createAction<SetLicenceStatusInput>(
  'licences/statusChangeRequested',
);

/**
 * Open Edit licence on a row: load the licence (for its CSM), the CSM
 * candidates and the client categories, side by side.
 */
export const editOpenRequested = createAction<string>('licences/editOpenRequested');

/** Save the Edit licence form. */
export const editSaveRequested = createAction<UpdateLicenceInput>('licences/editSaveRequested');

/** Add a client category from the Edit licence select (#604), Administrator only. */
export const clientCategoryAddRequested = createAction<string>(
  'licences/clientCategoryAddRequested',
);

/** Delete a row's licence for good, after the type-the-name confirmation. */
export const deleteRequested = createAction<string>('licences/deleteRequested');
